import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import { PortalShortcutCard } from './PortalShortcutCard';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useAuth } from '@/hooks/useAuth';
import { useOwnClientProfileQuery } from '@/hooks/useClientPortal';
import { useOwnClinicContactQuery } from '@/hooks/useOwnClinicContactQuery';
import { ClinicContactCard } from '../ClinicContactCard';
import { PortalPageHeader } from '../PortalPageHeader';
import { DetailsSubsection } from './DetailsSubsection';
import { LanguageSubsection } from './LanguageSubsection';
import { LegalDocumentsCard } from './LegalDocumentsCard';
import { MyDataCard } from './MyDataCard';

export function AccountPage() {
  const { t } = useTranslation('clients');
  const { logOut } = useAuth();
  const profileQuery = useOwnClientProfileQuery();
  const profile = profileQuery.data;
  const clinicContactQuery = useOwnClinicContactQuery();
  const clinicContact = clinicContactQuery.data;

  function signOut() {
    logOut();
  }

  return (
    <div className="p-4 sm:p-6 md:p-8">
      <PortalPageHeader
        title={t('portal.pages.account.title')}
        helperText={t('portal.pages.account.helper')}
      />
      <div className="space-y-5">
        {profileQuery.isLoading === true || profile === undefined ? (
          <Card as="section">
            <div className="py-6 flex justify-center">
              <LoadingSpinner className="w-6 h-6" />
            </div>
          </Card>
        ) : (
          <Card as="section">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-xl bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
                <Icon name="User" />
              </span>
              <h2 className="text-sm font-bold text-zooindigo">{t('portal.myProfileTitle')}</h2>
            </div>
            <div className="space-y-5">
              <DetailsSubsection profile={profile} />
              <LanguageSubsection />
            </div>
          </Card>
        )}
        <PortalShortcutCard
          iconName="ClipboardList"
          titleKey="portal.pages.account.formsLinkTitle"
          descriptionKey="portal.pages.account.formsLinkDescription"
          route={APPLICATION_ROUTES.clientPortalForms}
        />
        <PortalShortcutCard
          iconName="Megaphone"
          titleKey="portal.pages.account.announcementsLinkTitle"
          descriptionKey="portal.pages.account.announcementsLinkDescription"
          route={APPLICATION_ROUTES.clientPortalAnnouncements}
        />
        <MyDataCard />
        <LegalDocumentsCard />
        {clinicContact === undefined ? null : <ClinicContactCard clinicContact={clinicContact} />}
        <Card as="section">
          <Button
            variant="destructiveGhost"
            className="w-full border border-zooborder"
            onClick={signOut}
          >
            <Icon name="LogOut" />
            {t('portal.logout')}
          </Button>
        </Card>
      </div>
    </div>
  );
}
